module.exports = __webpack_public_path__ + "static/media/login.02f1ce72.jpg";